module.exports = "/_next/static/images/a242b331451985f6936b6d8d5faee593-cards@2x.png";